import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '../components/common/Layout'
import PermissionGate, { PermissionDenied } from '../components/common/PermissionGate'

// Client Pages
import ClientOverview from '../components/client/ClientOverview'
import ClientSites from '../components/client/ClientSites'
import MobileAwareEditor from '../components/client/MobileAwareEditor'
import ClientMedia from '../components/client/ClientMedia'
import ClientRequests from '../components/client/ClientRequests'
import ClientSettings from '../components/client/ClientSettings'
import ClientAnalytics from '../components/client/ClientAnalytics'
import ClientBilling from '../components/client/ClientBilling'
import ClientSupport from '../components/client/ClientSupport'
import DomainManagement from '../components/client/DomainManagement'
import NotificationsPage from '../components/client/NotificationsPage'
import SubscriptionGate from '../components/client/SubscriptionGate'

const ClientDashboard = () => {
  return (
    <SubscriptionGate>
    <Layout userRole="client">
      <Routes>
        <Route index element={<ClientOverview />} />
        
        <Route path="sites" element={
          <PermissionGate 
            permission="can_create_pages" 
            fallbackType="message"
            fallbackMessage="You need permission to create and manage pages to access this section."
          >
            <ClientSites />
          </PermissionGate>
        } />
        
        <Route path="sites/new" element={
          <PermissionGate 
            permission="can_create_pages" 
            fallbackType="message"
            fallbackMessage="You need permission to create and manage pages to access this section."
          >
            <ClientSites openNew />
          </PermissionGate>
        } />
        
        <Route path="editor/*" element={
          <PermissionGate 
            permissions={['can_edit_text', 'can_upload_media']}
            fallbackType="message"
            fallbackMessage="You need permission to edit content or upload media to access the editor."
          >
            <MobileAwareEditor />
          </PermissionGate>
        } />
        
        <Route path="media/*" element={
          <PermissionGate 
            permission="can_upload_media"
            fallbackType="message"
            fallbackMessage="You need permission to upload media to access this section."
          >
            <ClientMedia />
          </PermissionGate>
        } />
        
        <Route path="requests/*" element={
          <PermissionGate 
            permission="can_access_support"
            fallbackType="message"
            fallbackMessage="You need permission to access support to view this section."
          >
            <ClientRequests />
          </PermissionGate>
        } />
        
        <Route path="domains/*" element={
          <PermissionGate 
            permission="can_manage_domains"
            fallbackType="message"
            fallbackMessage="You need permission to manage domains to access this section."
          >
            <DomainManagement />
          </PermissionGate>
        } />
        
        <Route path="settings/*" element={<ClientSettings />} />
        
        <Route path="analytics/*" element={
          <PermissionGate 
            permission="can_view_analytics"
            fallbackType="message"
            fallbackMessage="You need permission to view analytics to access this section."
          >
            <ClientAnalytics />
          </PermissionGate>
        } />
        
        <Route path="billing/*" element={
          <PermissionGate 
            permission="can_view_billing"
            fallbackType="message"
            fallbackMessage="You need permission to view billing information to access this section."
          >
            <ClientBilling />
          </PermissionGate>
        } />
        
        <Route path="help/*" element={
          <PermissionGate
            permission="can_access_support"
            fallbackType="message"
            fallbackMessage="You need permission to access the help center to view this section."
          >
            <ClientSupport />
          </PermissionGate>
        } />

        {/* Legacy path — keep old links/bookmarks/notifications working */}
        <Route path="support/*" element={<Navigate to="/client/help" replace />} />

        <Route path="notifications/*" element={<NotificationsPage />} />
      </Routes>
    </Layout>
    </SubscriptionGate>
  )
}

export default ClientDashboard